import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaHome, FaTools, FaPlus } from 'react-icons/fa';
import styles from '../home/ServiceSelector.module.css';
import { dashboardsFor, LIST_PROPERTY_PATH } from '../../features/dashboards';

const icons = { property: <FaHome />, provider: <FaTools />, list: <FaPlus /> };

// Header links to the user's dashboards (icon buttons on desktop, labelled
// buttons in the mobile menu). Users without a listing get "List your property".
const DashboardShortcuts = ({ user, variant = 'desktop', onNavigate }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!user) return null;

  const links = dashboardsFor(user);
  if (!links.some((l) => l.key === 'property')) {
    links.unshift({ key: 'list', to: LIST_PROPERTY_PATH, label: 'sidebar.list_property' });
  }

  const go = (to) => {
    navigate(to);
    onNavigate?.();
  };

  return links.map(({ key, to, label }) =>
    variant === 'mobile' ? (
      <button key={key} onClick={() => go(to)} className={styles.mobileRegisterBtn}>
        {icons[key]}<span>{t(label)}</span>
      </button>
    ) : (
      <button key={key} onClick={() => go(to)} className={styles.avatarBtn} title={t(label)} aria-label={t(label)}>
        {icons[key]}
      </button>
    )
  );
};

export default DashboardShortcuts;
